<template>
    <auth-layout>
        <div class="container mt-5 mb-3 pt-5">
            <div class="row justify-content-center">
                <div class="col-md-10 col-xl-8">
                    <form class="card"
                          autocomplete="off"
                          autocapitalize="off"
                          @submit.prevent="submit()">
                        <div class="card-header">
                            <logo class="text-center" :show-name="true"/>
                        </div>
                        <div class="card-body">

                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="first-name">First Name</label>
                                        <input type="text" id="first-name" class="form-control" placeholder="First Name" v-model="form.first_name">
                                        <error-line field="first_name"/>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="name">Last Name</label>
                                        <input type="text" id="name" class="form-control" placeholder="Last Name" v-model="form.last_name">
                                        <error-line field="last_name"/>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="email">Email</label>
                                        <input type="email"
                                               id="email"
                                               class="form-control"
                                               placeholder="example@domain.com"
                                               v-model="form.email">
                                        <error-line field="email"/>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="referred-by">Project Name</label>
                                        <input class="form-control"
                                               type="text"
                                               v-model="form.project_name"
                                               id="referred-by"
                                               placeholder="Enter your project name">
                                        <error-line field="referred_by"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer d-flex align-items-center">
                            Already Registered?
                            <inertia-link class="ml-1" :href="route('login', {...global_url_params})">
                                Login Now.
                            </inertia-link>

                            <div class="actions ml-auto">
                                <state-button class="btn btn-dark"
                                              type="submit"
                                              :state="is_busy ? 'busy' : ''"
                                              :disabled="is_busy">Register</state-button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from "@/Layouts/AuthLayout";
import Logo from "@/Components/Common/Logo";
import API from "@/API";
import {validate} from "@/helpers/validate";
import ErrorLine from "@/Components/Common/ErrorLine";
import StateButton from "@/Components/Common/StateButton";
import Slider from '@vueform/slider';
import mixpanel from "mixpanel-browser";
import utils from "@/mixins/utils";

export default {
    name: "QuickRegister",
    components: {StateButton, ErrorLine, AuthLayout, Logo, Slider},
    mixins: [utils],
    props: ['organization'],

    data(){
        return {

            debouncedPlaceSearch: _.debounce(() => this.searchPlace(), 500),

            is_busy: false,

            search: {
                is_busy: false,
                selected: null,
                query: '',
                results: [],
            },

            form: this.$inertia.form({
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                password_confirmation: '',
                referred_by: '',
                project_name: '',
                number_of_students: 10,
                has_organization: true,
                create_organization: false,
                organization: {
                    name: '',
                    address: '',
                    type: null,
                    id: null,
                }
            }),
        }
    },

    computed: {

        is_invalid(){
            return !this.is_valid;
        },

        is_valid(){
            return this.form.first_name.length
                && this.form.last_name.length
                && (this.form.email.length && validate.email( this.form.email ))
                && ( this.form.password.length && this.form.password === this.form.password_confirmation)
                && (this.form.number_of_students >= 0 )
                && (
                    this.form.has_organization
                        ? (
                              this.form.create_organization
                                  ? (this.form.organization.name.length && this.form.organization.address.length)
                                  : (this.form.organization.id && this.form.organization.type)
                        )
                        : true
                );
        },

        selected_item_id(){
            return this.search.selected;
        },

        referred_org(){
            if( ! this.organization ) return;
            return {
                id: `org-${this.organization.id}`,
                type: 'org',
                value: this.organization,
            };
        },

        registered() {
            return 'registered';
        }

    },


    watch: {
        selected_item_id(val){
            const selected = this.search.results.find(item => item.id === val);

            if( selected ){
                this.form.organization.id = selected.type === 'ac' ? selected.value.place_id : selected.value.id;
                this.form.organization.type = selected.type;
            }else{
                this.form.organization.id = null;
                this.form.organization.type = null;
            }
        }
    },


    methods: {

        submit(){
            this.form.post(this.route('quickregister', {...this.global_url_params}), {
                onStart: () => this.is_busy = true,
                onFinish: () => this.form.reset('password', 'password_confirmation'),
                onSuccess: (res) => {
                    mixpanel.track('REGISTER', this.utils.flatten(res.props.user));
                    mixpanel.identify(res.props.user.id);
                },
                onError: () => this.is_busy = false,
            });
        }

    },

    mounted() {
        this.setTitle( 'Register for Design for Change USA' );

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.get('email') != '') this.form.email = urlParams.get('email');

        if( this.referred_org ){
            this.search.results = [ this.referred_org ];
            // this.search.query = this.organization.name;
            this.search.selected = this.search.results[0].id;
        }
    }

}
</script>

<style lang="scss" scoped>
.search-item{
    border-bottom: $light-borders solid 1px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.user-count{
    display: inline-block;
    color: $do;
    margin-left: .3rem;
}
</style>
